import { Resource } from "@q-food/q-food";
import { useFormSchema } from "./useFormSchema";
import { useFormSubmit } from "./useFormSubmit";

// header-case to pascalCase
function toPascalCase(str: string) {
	return str
		.split("-")
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join("");
}

const getFormName = (key: string, type: "Edit" | "Create") => {
	key = toPascalCase(key);

	return `${type}${key}Form`;
};

/**
 * Utility function for forms with a given resource
 */
function useForm<T>(formName: string, resource: Resource, resourceId?: string, model?: Ref<Record<string, any>>) {
	const { formArrayDefinition, formObjectDefinition, originalFormValues } = useFormSchema<T>(formName, resourceId);

	const { submitForm, onSubmitError, onSubmitSuccess } = useFormSubmit<T>(resource, resourceId);

	const isReady = ref(false);

	watch(
		originalFormValues,
		(values: Record<string, any>) => {
			if (Object.keys(values).includes("filesToDelete")) {
				values["filePreviewMode"] = "list";
			}

			model.value = { ...values };
			isReady.value = true;
			console.log("useForm klaar");
		},
		{ once: true },
	);

	return {
		isReady,
		submitForm,
		onSubmitError,
		onSubmitSuccess,
		formArrayDefinition,
		formObjectDefinition,
		originalFormValues,
	};
}

export { getFormName, useForm };
